var c = "<svg slot=\"icon\" height=\"10px\" width=\"10px\" viewbox=\"0 0 10 10\" xmlns=\"http://www.w3.org/2000/svg\" class=\"fallback-icon\">\n    <circle cx=\"5\" cy=\"5\" r=\"5\" />\n</svg>";
export { c };